import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';
import sharedTheme from '../OverlayTheme.css';
import theme from './theme.css';

const AreYouWatching = (props = {}) => {
  const { background, onClose } = props;
  return (
    <div className={sharedTheme.container}>
      <img className={sharedTheme.background} src={background} alt="" />
      <div className={sharedTheme.messageContainer}>
        <div className={classNames(theme.title, sharedTheme.title)}>Are You Still Watching?</div>
        <div className={classNames(theme.message, sharedTheme.message)}>
          <Link className={theme.button} onClick={onClose}>
            Yes, continue watching
          </Link>
        </div>
      </div>
    </div>
  );
};

AreYouWatching.propTypes = {
  background: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AreYouWatching;
